export const hints: { [key: string]: string } = {
  ['MISNAP_HEAD_OUTSIDE']: 'lbl.face_in_oval',
  ['MISNAP_HEAD_SKEWED']: 'lbl.look_straight',
  ['MISNAP_AXIS_ANGLE']: 'lbl.hold_phone_upright',
  ['MISNAP_HEAD_TOO_CLOSE']: 'lbl.move_farther',
  ['MISNAP_HEAD_TOO_FAR']: 'lbl.get_closer',
  ['MISNAP_STAY_STILL']: 'lbl.hold_still',
  ['MISNAP_SUCCESS']: 'lbl.success',
  ['MISNAP_STOP_SMILING']: 'lbl.stop_smiling',
  ['MISNAP_SMILE']: 'lbl.smile',
  ['MISNAP_READY_POSE']: 'lbl.hold_position',
  ['NO_FACE_FOUND']: 'lbl.face_not_found',
  ['MITEK_ERROR_GLARE']: 'lbl.reduce_glare',
  ['MITEK_ERROR_FOUR_CORNER']: 'lbl.doc_not_found',
  ['MITEK_ERROR_TOO_DARK']: 'lbl.reduce_darkness',
  ['MITEK_ERROR_FOCUS']: 'lbl.hold_steady',
  ['MITEK_ERROR_MRZ_MISSING']: `lbl.passport_read_page_error`,
  ['CV_NO_BARCODE_FOUND']: 'lbl.scanning_barcode',
  ['MITEK_ERROR_TOO_FAR']: 'lbl.doc_too_far',
  ['MITEK_ERROR_TOO_CLOSE']: 'lbl.doc_too_close',
  ['MITEK_ERROR_NOT_CENTERED']: 'lbl.doc_not_centered',
  ['MITEK_ERROR_MIN_PADDING']: 'lbl.move_further',
  ['MITEK_ERROR_HORIZONTAL_FILL']: 'lbl.move_closer',
  ['MITEK_ERROR_LOW_CONTRAST']: 'lbl.doc_center_dark_background',
  ['MITEK_ERROR_BUSY_BACKGROUND']: 'lbl.doc_center_plain_background',
  ['MITEK_ERROR_SKEW_ANGLE']: 'lbl.reduce_angle'
};
